import PropTypes from "prop-types";
import { Calendar, Package, Truck } from "lucide-react";
import { Card, CardHeader, MetadataField, Divider } from "../ui";

const EcommerceInfo = ({ metadata }) => {
  const display = metadata?.display || {};
  const hasInfo =
    display.order_number ||
    display.shipping_address ||
    display.estimated_delivery;

  if (!hasInfo) return null;

  return (
    <Card className="mb-4">
      <div className="px-4 sm:px-6 pt-4 sm:pt-5 pb-2 sm:pb-3">
        <h3 className="text-sm sm:text-base font-bold" style={{ color: "#3B3B3B" }}>
          Order Details
        </h3>
      </div>
      <div className="px-4 sm:px-6 pb-4 sm:pb-5">
        <div className="space-y-1">
          {display.order_number && (
            <div className="py-2 sm:py-3">
              <div className="flex items-center gap-2 mb-1">
                <Package className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" style={{ color: "#515164" }} />
                <span className="text-xs sm:text-sm font-medium" style={{ color: "#3B3B3B" }}>
                  Order Number
                </span>
              </div>
              <div className="pl-5 sm:pl-6">
                <span className="text-xs sm:text-sm font-semibold" style={{ color: "#01793B" }}>
                  {display.order_number}
                </span>
              </div>
            </div>
          )}

          {display.order_date && (
            <MetadataField
              icon={Calendar}
              label="Order Date"
              value={new Date(display.order_date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            />
          )}

          {display.shipping_address && (
            <MetadataField
              label="Shipping Address"
              value={display.shipping_address}
              isMultiline
            />
          )}

          {display.billing_address && (
            <MetadataField
              label="Billing Address"
              value={display.billing_address}
              isMultiline
            />
          )}

          {display.estimated_delivery && (
            <div className="py-2 sm:py-3">
              <div className="flex items-center gap-2 mb-1">
                <Truck className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" style={{ color: "#515164" }} />
                <span className="text-xs sm:text-sm font-medium" style={{ color: "#3B3B3B" }}>
                  Estimated Delivery
                </span>
              </div>
              <div className="pl-5 sm:pl-6">
                <span className="text-xs sm:text-sm font-semibold" style={{ color: "#01793B" }}>
                  {new Date(display.estimated_delivery).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    },
                  )}
                </span>
              </div>
            </div>
          )}

          {display.delivery_method && (
            <MetadataField label="Delivery Method" value={display.delivery_method} />
          )}

          {display.tracking_number && (
            <div className="py-2 sm:py-3">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs sm:text-sm font-medium" style={{ color: "#3B3B3B" }}>
                  Tracking Number
                </span>
              </div>
              <div className="pl-5 sm:pl-6">
                <span className="text-xs sm:text-sm font-semibold break-all" style={{ color: "#01793B" }}>
                  {display.tracking_number}
                </span>
              </div>
            </div>
          )}

          {display.customer_notes && <Divider />}

          {display.customer_notes && (
            <MetadataField label="Customer Notes" value={display.customer_notes} isMultiline />
          )}
        </div>
      </div>
    </Card>
  );
};

EcommerceInfo.propTypes = {
  metadata: PropTypes.shape({
    display: PropTypes.shape({
      order_number: PropTypes.string,
      order_date: PropTypes.string,
      shipping_address: PropTypes.string,
      billing_address: PropTypes.string,
      estimated_delivery: PropTypes.string,
      delivery_method: PropTypes.string,
      tracking_number: PropTypes.string,
      customer_notes: PropTypes.string,
    }),
  }),
};

export default EcommerceInfo;
